import { APICore } from 'helpers/api/apiCore'

const api = new APICore()

export function getKanban() {
  return api.get(`Kanban/kanban`, null)
}
